import { Col, List, Modal, Row, Space, Image, Typography, Card, Spin } from "antd";
import React, { ReactNode, useEffect, useState } from "react";
import Title from "antd/es/typography/Title";
import styles from "./CardModal.module.css";
import Paragraph from "antd/es/typography/Paragraph";
import { useDispatch, useSelector } from "react-redux";
import PublicCollectionsDataSlice from "../../Slices/PublicCollectionsDataSlice";
import CardModalFooter from "../CardModalFooter/CardModalFooter";
import { sendData } from "../../Slices/ModalSlice";
import Link from "antd/es/typography/Link";
const { Text } = Typography;

interface IconTextProps {
  icon: React.ElementType;
  text: ReactNode;
}

function capitalizeName(name: string): string {
  return name
    .split(' ')
    .map(word => word.replace(/^\w/, c => c.toUpperCase()))
    .join(' ');
}

const IconText: React.FC<IconTextProps> = ({ icon, text }) => (
  <Space>
    {React.createElement(icon)}
    {text}
  </Space>
);

const CardModal = (props: any) => {
  const { open, setOpen } = props;
  const dispatch = useDispatch();
  
  const {loader, modalResponse} = useSelector((state: any) => state.publicCollectionsData);
  
  const [paraRows, setParaRows] = useState(2);

  
  const items = useSelector((state: any) => state.publicCollectionsData.items);


  const textItems = !items
    ? null
    : items?.preview_items?.filter((item: any) => item.type === "text");
  const urlItems = !items
    ? null
    : items?.preview_items?.filter((item: any) => item.type === "url");
  const imgItems = !items
    ? null
    : items.preview_items?.filter((item: any) => item.type === "img");
  const { title, url, details, publish_date, author, id } = !items ? "" : items.details;
  const collectionUrl = url ? url : 'url';
  const authorName = author ? capitalizeName(author.name) : 'user';

  useEffect(()=>{
    dispatch(sendData({title, collectionUrl, authorName, id}));
  })

  const dateOnly = publish_date ? publish_date : "N/A";

  const data2 = Array.from({
    length: 2,
  }).map((_, i) => ({
    href: "https://ant.design",
    title: `ant design part ${i}`,
    avatar: `https://xsgames.co/randomusers/avatar.php?g=pixel&key=${i}`,
    description: "imagecollection",
    content:
      "We supply a series of design principles, practical patterns and high quality design resources (Sketch and Axure), to help people create their product prototypes beautifully and efficiently.",
  }))

  const modaltitle = (
    <Row
      style={{ borderBottom: "0.5px solid #bbdaf4", padding: "7px 0px"}}
      justify={"space-between"}
    >
      <Col span={24}>
        <Title style={{margin: 0}} level={3}>{!title ? "" : title.slice(0, 50) + ".."}</Title>
      </Col>
      {/* <Col className={styles.modalHeaderIconsDiv} span={6}>
        <i className={`bi bi-pencil-square h5 ${styles.modalHeaderIcon}`}></i>
        <i className={`bi bi-link-45deg h4 ${styles.modalHeaderIcon}`}></i>
        <i
          className={`bi bi-box-arrow-up-right h5 ${styles.modalHeaderIcon}`}
        ></i>
        <i className={`bi bi-eye-fill h5 ${styles.modalHeaderIcon}`}></i>
        <i className={`bi bi-bookmark h5 ${styles.modalHeaderIcon} `}></i>
      </Col> */}
    </Row>
  );
  return (
    <>
      
      {!items ? null
      : modalResponse && ( 
        <Modal
          className={styles.modalParent}
          title={modaltitle}
          styles={{}}
          centered
          open={open}
          okText={"View Full"}
          onOk={() => null}
          onCancel={() =>{ setOpen(false); }}
          width={700}
          footer={<CardModalFooter slug={items?.details?.slug}/>}
        > 
          <Row 
          className={styles.modalMain} style={{ gap: "5px" }}>
            {/* <Col style={{ display: "flex", flexDirection: "row" }} span={24}>
              <Col
                style={{ display: "flex", justifyContent: "flex-start" }}
                span={12}
              >
                Creator - {author.name}
              </Col>
              <Col className="center" span={6}>
              {"type"}
            </Col>
            <Col className="center" span={6}>
              {"language"}
            </Col>
              <Col
                style={{ display: "flex", justifyContent: "flex-end" }}
                span={12}
              >
                Published On - {dateOnly}
              </Col>
            </Col> */}
            { details.description_text ?
            <Col span={24}>
              {/* <Title className={styles.textMargin0} level={5}>
                Description -
              </Title> */}
                       <Paragraph style={{paddingTop: "6px"}} ellipsis={{symbol: "Read more", rows: 2, expandable: true,  }}>
                    {details.description_text}
                        </Paragraph>
            </Col> : <Paragraph style={{paddingTop: "6px", fontWeight: "500"}}>No Description</Paragraph>
}
            
          { textItems?.length >0 ?
            <Col span={24}>
                  {/* <Title className={styles.textMargin0} level={5}>
                Text -
              </Title> */}
              <List
                itemLayout="horizontal"
                dataSource={textItems}
                renderItem={(item: any) => (
                  <List.Item>
                    <List.Item.Meta
                      // avatar={<Avatar src={`https://xsgames.co/randomusers/avatar.php?g=pixel&key=${index}`} />}
                      title={item.title}
                      description={
                        <Paragraph ellipsis={{symbol: "Read more", rows: 2, expandable: true, }}>
                          {item.description_text}
                        </Paragraph>
                      }
                    />
                  </List.Item>
                )}
              />
            </Col> : null
}

          { urlItems?.length >0 ?
            <Col span={24}>
              <Title className={styles.textMargin0} level={5}>
                Links -
              </Title>
              <List
                itemLayout="horizontal"
                dataSource={urlItems}
                renderItem={(item: any) => (
                  <List.Item>
                    <List.Item.Meta
                      // avatar={<Avatar src={`https://xsgames.co/randomusers/avatar.php?g=pixel&key=${index}`} />}
                      title={<Link ellipsis target="_blank" href={item.url}>{item.title}</Link>}
                      description={
                        <Paragraph  ellipsis={{symbol: "Read more", rows: 2, expandable: true }}>
                          {item.description}
                        </Paragraph>
                      }
                    />
                  </List.Item>
                )}
              />
            </Col>: null
}
          
          { imgItems?.length >0 ?
            <Col span={24}>
              <Title className={styles.textMargin0} level={5}>
                Images -
              </Title>
              <List
                itemLayout="vertical"
                size="default"
                dataSource={imgItems}
                footer={null}
                renderItem={(item: any) => (
                  <List.Item
                    key={item.title}
                    // actions={[
                    // <IconText icon={StarOutlined} text="156" key="list-vertical-star-o" />,
                    // <IconText icon={LikeOutlined} text="156" key="list-vertical-like-o" />,
                    // <IconText icon={MessageOutlined} text="2" key="list-vertical-message" />,
                    // ]}
                    extra={
                      <Image
                        className="pointer"
                        preview={true}
                        width={100}
                        height={100}
                        style={{objectFit: "cover"}}
                        src={item.file ? item.file.url : item.url}
                      ></Image>
                    }
                  >
                    <List.Item.Meta
                      // avatar={<Avatar src={item.avatar} />}
                      title={item.title ?? <a target="_blank" href={item.href}>{item.title}</a>}
                      description={
                        <Paragraph ellipsis={{symbol: "Read more", rows: 3, expandable: true }}>
                          {item.description}
                        </Paragraph>
                      }
                    />
                  </List.Item>
                )}
              />
            </Col> : null
}
    { items?.items?.length - items?.preview_items?.length > 0 &&
      <Col span={24} style={{textAlign:"left", marginTop: "10px"}}>
        <Text>and {items?.items?.length - items?.preview_items?.length} more items.</Text>
        </Col>
}

          </Row> 
          {/* hey */}
        </Modal> 
      )}
    </>
  );
};

export default CardModal;
